/**
 * Org-role helpers. cavort-auth's `/auth/me` returns the active-org role as a
 * flat `role` field ("owner" | "admin" | "member"); `isAdmin` on the same
 * object is the PLATFORM superadmin flag and is deliberately not consulted
 * here — platform admins still act under their org role inside an org.
 */
export function isOrgAdmin(user: { role?: string | null } | null | undefined): boolean {
	return user?.role === "owner" || user?.role === "admin";
}

/**
 * True when the user is scoped to a Store (`store_user` row), which the
 * backend reports as `storeId` on the store-app profile call.
 *
 * Store scoping is Burresi-side, NOT a cavort-auth role: `auth_member.role` is
 * owned by the shared auth lib and a store user is a plain `member` there.
 */
export function isStoreUser(store: { storeId?: string | null } | null | undefined): boolean {
	return Boolean(store?.storeId);
}
